import PaymentReceiptThankyou from 'shared-assets/components/PaymentSolutions/ReceiptPage/ThankYou';

angular
  .module('kareo.ui.shared.directives.payment-receipt-thankyou', [
    'react'
  ])
  .directive('paymentReceiptThankyou', dcPaymentReceiptThankyou);

dcPaymentReceiptThankyou.$inject = ['reactDirective'];

function dcPaymentReceiptThankyou(reactDirective) {
  const bindings = { };

  return reactDirective(PaymentReceiptThankyou, bindings, props => {
    return props;
  });
}
